import React from 'react';
import { Link } from 'react-router-dom';
import "./mynav.css"



function NavBar({crrUser,logout}) {
  return <>

<nav className="navbar navbar-expand-lg navbar-dark">
  <div className="container-fluid">
    <Link to="home" className="navbar-brand maintitle bg-gradient logo p-3 rounded-2" >ET</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
       <ul className="navbar-nav me-auto mb-2 mb-lg-0 text-center">
        <li className="nav-item">
          <Link to="home" className="nav-link active" aria-current="page">Home</Link>
        </li>
        <li className="nav-item">
          <Link to="movies" className="nav-link active" aria-current="page">Movies</Link>
        </li>
        <li className="nav-item">
          <Link to="series" className="nav-link active" aria-current="page">Series</Link>
        </li>
        <li className="nav-item">
          <Link to="people" className="nav-link active" aria-current="page">People</Link>
        </li>
        <li className="nav-item">
          <Link to="search" className="nav-link active" aria-current="page">Search</Link>
        </li>
      </ul>
      <ul className="navbar-nav ms-auto mb-2 align-items-center mb-lg-0">
        <li className='nav-item'>
        <i className="fa-brands me-3 fa-facebook"></i>
        <i className="fa-brands me-3 fa-twitter"></i>
        <i className="fa-brands me-3 fa-spotify"></i>
        <i className="fa-brands me-3 fa-instagram"></i>
        </li>
      </ul>
    </div>
  </div>
</nav>
  
</>
}

export default NavBar;


